import { render, staticRenderFns } from "./RightTabAction.vue?vue&type=template&id=87263184&scoped=true&"
import script from "./RightTabAction.vue?vue&type=script&lang=js&"
export * from "./RightTabAction.vue?vue&type=script&lang=js&"
import style0 from "./RightTabAction.vue?vue&type=style&index=0&id=87263184&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87263184",
  null
  
)

export default component.exports